<template>
  <div>
    <a-form class="ant-advanced-search-form oa-ant-advanced-search-form" :form="form">
      <a-row class="search-form-row" v-for="(item,index) in searchConditions" :key="index" v-if="isShowAdvanced?index<searchConditions.length:index===0">
        <a-col v-for="(child,ind) in item" :key="ind">
          <a-form-item :label="child.label" v-if="child.type==='input'">
            <a-input v-decorator="[
                child.field,
              ]" :placeholder="child.placeholder" />
          </a-form-item>
          <a-form-item :label="child.label" v-if="child.type==='select' || child.type==='complexSelect'">
            <a-select v-decorator="[
          child.field,
          {initialValue:queryParams[child.field]&&!child.loading?queryParams[child.field]:undefined}
        ]" :placeholder="child.placeholder" :allowClear="true" showSearch :filterOption="selectFilterOption" @focus="selectFocus(child)" @change="value=>onChangeSelect(value,child)">
              <a-select-option :value="item.id" v-for="(item,index) in child.options" :key="index" v-if="child.type==='select'">
                {{item.name}}
              </a-select-option>
              <a-select-option :value="item.id" v-for="(item,index) in child.options" :key="index" v-if="child.type==='complexSelect'">
                <span>{{item.name}}{{item.job_code}}</span>
                <span class="select-options-detail"><br> {{item.job_desc}}</span>
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="child.label" v-if="child.type==='range'">
            <a-range-picker v-decorator="[child.field, {
              initialValue:queryParams[child.field]?queryParams[child.field].map(item=>moment(item)):[],
        rules: [{ type: 'array', }],
      }]" :allowClear="true" />
          </a-form-item>
        </a-col>
        <div style="display:flex;" class="btnGroup" v-if="isShowAdvanced?index===searchConditions.length-1:index===0">
          <a-button type="primary" @click="query">搜索</a-button>
          <a-button v-if="isShowAdvanced" @click="clear">清空</a-button>
          <a-button type="link" @click="openAdvanced">
            <span v-if="isShowAdvanced">关闭</span>高级搜索</a-button>
        </div>
      </a-row>
    </a-form>
  </div>
</template>
<script>
import moment from 'moment';

export default {
  props: {
    searchConditions: Array,
    showAdvanced: {
      default: false,
      type: Boolean,
    },
    queryParams: Object,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      isShowAdvanced: false,
    };
  },
  computed: {},
  methods: {
    moment,
    openAdvanced() {
      this.isShowAdvanced = !this.isShowAdvanced;
      // if(this.showAdvanced){
      //   this.searchConditions[0].
      // }
    },
    clear() {
      // this.form.resetFields();
      let formConfigs = [];
      this.searchConditions.forEach(item => {
        item.forEach(child => {
          formConfigs.push(child);
        });
      });
      let formParams = this.form.getFieldsValue();
      Object.keys(formParams).forEach(key => {
        const config = formConfigs.find(item => item.field === key);
        formParams[key] = undefined;
        if (config.type === 'range') {
          formParams[key] = [];
        }
      });
      this.form.setFieldsValue(formParams);
      this.query();
    },
    query() {
      let formatted = this.form.getFieldsValue();
      let formattedBackup = _.cloneDeep(formatted);
      this.searchConditions.forEach(item => {
        item.forEach(child => {
          if (child.type === 'range' && formattedBackup[child.field]) {
            formattedBackup[child.field].forEach((children, index) => {
              formattedBackup[child.field][index] = moment(children).format(
                'YYYY-MM-DD',
              );
            });
          }
        });
      });
      this.$emit('query', formattedBackup);
    },
    selectFilterOption(input, option) {
      if (this.selectType === 'complexSelect') {
        return option.componentOptions.children[0].children[0].text.includes(
          input,
        );
      } else {
        return option.componentOptions.children[0].text.includes(input);
      }
    },
    selectFocus(config) {
      this.selectType = config.type;
    },
    onChangeSelect(val, config) {
      let params = {};
      params[config.field] = val;
      this.$emit('update-params', params);
      if (config.triggerField) {
        let target = {};
        this.searchConditions.forEach(item => {
          item.forEach(child => {
            if (child.field === config.triggerField) {
              target = child;
            }
          });
        });
        let formParams = this.form.getFieldsValue();
        formParams[config.triggerField] = undefined;
        this.form.setFieldsValue(formParams);
        this.$emit('update-option', target);
      }
    },
  },
  created() {
    this.isShowAdvanced = this.showAdvanced;
  },
};
</script>
<style lang="less">
.oa-ant-advanced-search-form {
  margin-bottom: 25px;
  .search-form-row {
    display: flex;
    flex-wrap: wrap;
    .btnGroup {
      display: flex;
      .ant-btn {
        margin-right: 16px;
      }
    }
  }
  .ant-form-item {
    display: flex;
    margin-bottom: 16px;
    margin-right: 24px;
    .ant-form-item-label {
      line-height: 28px;
      label {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .ant-select-selection--single {
      height: 30px;
      .ant-select-selection__rendered {
        line-height: 28px;
        .ant-select-selection-selected-value {
          .select-options-detail {
            display: none;
          }
        }
      }
    }
    .ant-input {
      height: 30px;
    }
    .ant-form-item-control-wrapper {
      min-width: 190px;
      line-height: 28px;
      flex: 1;

      .ant-form-item-control {
        line-height: 28px;
      }
    }
  }
  .ant-btn {
    height: 30px;
  }
}
</style>